// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubBrandTab_wrapper__1yHZ5"};